var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:'route-' + _vm.route.key},[_c('l-polyline',{attrs:{"lat-lngs":_vm.positions,"color":_vm.route.color,"weight":_vm.weight}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }